
define('txt!tmpl/generic.loader.hbs',[],function () { return '<div class="loader"></div>\n';});

